<div class="row detail-content__row">
  <div class="col-12 col-lg-2">
    <h5 class="detail-steps__title">Facilities</h5>
  </div>
  <div class="col-12 col-lg-10">
    <div class="e-list-services e-list-services-wrap">
      <ul>
        <li *ngFor="let facility of facilities">{{facility.name}}</li>
      </ul>
    </div>
  </div>
</div>
